import {
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
  AfterViewInit,
  Input,
} from '@angular/core';
import * as _ from 'lodash';

@Directive({
    selector: '[prCollapse]',
    standalone: false
})
export class EaCollapseDirective implements AfterViewInit {
  @Output() prCollapseChange: EventEmitter<any> = new EventEmitter();
  @Input() prCollapse: boolean;
  elemenCollapses;
  mainElement;
  maxHeight;

  constructor(private _elementRef: ElementRef) {}
  outerHeight(elem: HTMLElement, includeMargin: boolean): number {
    let height = elem.offsetHeight;
    if (includeMargin) {
      let computedStyle = window.getComputedStyle(elem);
      let marginTop = parseFloat(computedStyle.marginTop);
      let marginBottom = parseFloat(computedStyle.marginBottom);
      height += marginTop + marginBottom;
    }
    return height;
  }
  ngAfterViewInit() {
    this.mainElement = this._elementRef.nativeElement.children[0];
    this.elemenCollapses = this._elementRef.nativeElement.querySelectorAll(
      '[collapse-list] > *',
    );
    this._elementRef.nativeElement.style.maxHeight =
      this.mainElement.scrollHeight + 'px';
    this.maxHeight = _(_.union(this.elemenCollapses, [this.mainElement]))
      .map(o => this.outerHeight(o, true))
      .sum();
    this.collapseElements(true);

    if (this.prCollapse) {
      this._elementRef.nativeElement.classList.toggle('open');
      this.openElement();
    }
  }

  @HostListener('click', ['$event.target'])
  public onClick(targetElement) {
    if (targetElement.closest('[collapse-toggle]')) {
      this._elementRef.nativeElement.classList.toggle('open');
      if (this._elementRef.nativeElement.classList.contains('open')) {
        this.openElement();
      } else {
        this.collapseElements(false);
      }
    }
  }

  openElement() {
    this._elementRef.nativeElement.style.maxHeight = `${this.maxHeight}px`;
    this.prCollapseChange.emit(true);
  }

  collapseElements(first: boolean) {
    this._elementRef.nativeElement.style.maxHeight = `${this.mainElement.scrollHeight}px`;
    _.map(this.elemenCollapses, (o, i: number) => {
      if (first) o.style.transition = '0s all ease';
      if (i > 0)
        o.style.transform = `translateY(${
          -(o.scrollHeight * (i + 1)) - i * 5
        }px)`;
      else o.style.transform = `translateY(${-o.scrollHeight}px)`;
      setTimeout(() => {
        if (first) o.style.transition = '1s all ease';
      }, 0);
    });
    this.prCollapseChange.emit(false);
  }
}
